if (typeof boostPFSThemeConfig !== 'undefined') {
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
			// Optional
			loadProductFirst: false,
			styleScrollToTop: 'style2',
			defaultDisplay: boostPFSThemeConfig.custom.layout,
			showPlaceholderProductList: true
		},
		selector: {
			otpButtons: '.grid-view-item__image-container'
		},
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
      
    var extra_label = Utils.getProductMetafield(this.data , 'custom' , 'extra_label');
    var pre_launch  = Utils.getProductMetafield(this.data , 'custom' , 'pre_launch');
    
      	// Build Badges
      	var itemBadgesHtml = '';
        if (boostPFSThemeConfig.custom.product_grid_show_sale_badge && onSale && !soldOut) {
          itemBadgesHtml += '<div class="rm-sale-label desktop-visible px-2 lg:px-4 z-10 p-2 rm-text-bold bg-{{sectionColor}}-accent text-{{sectionColor}}-text-overlay absolute bottom-4 right-4">';
          itemBadgesHtml += 'Sconto del ' + data.percent_sale_min + '%';
          itemBadgesHtml += '</div>';
        }
        // if(soldOut){
        //   itemBadgesHtml += '<div class="product-badges">';
        //   itemBadgesHtml += '<div class="product-badge sold">';
        //   itemBadgesHtml += '<span>Sold out - <a href="/pages/store-locator" class="find-stockist">Find a stockist</a></span>';
        //   itemBadgesHtml += '</div>';
        //   itemBadgesHtml += '</div>';
        // }else if 
    
       if(soldOut && pre_launch != null ){
          itemBadgesHtml += '<div class="product-badges">';
          itemBadgesHtml += '<div class="product-badge sold">';
          // itemBadgesHtml += '<span>Sold out - <a href="/pages/store-locator" class="find-stockist">Find a stockist</a></span>';
         if(extra_label != null) {
          itemBadgesHtml += '<span>'+ extra_label +'</span> <br/>';
         }
          itemBadgesHtml += '<span>'+ pre_launch +'</span>';
          itemBadgesHtml += '</div>';
          itemBadgesHtml += '</div>';
       }else if (soldOut) {
          itemBadgesHtml += '<div class="product-badges">';
          itemBadgesHtml += '<div class="product-badge sold">';
         if(extra_label != null) {
          itemBadgesHtml += '<span>'+ extra_label +'</span> <br/>';
         }
          itemBadgesHtml += '<span>Sold out - <a href="/pages/store-locator" class="find-stockist">Find a stockist</a></span>';
          itemBadgesHtml += '</div>';
          itemBadgesHtml += '</div>';
       }
    
    console.log(Utils.getProductMetafield(this.data , 'custom' , 'extra_label'))
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);
      
      	// Build Images
      	var itemImagesHtml = '';
      	var object_contain_grid = false;
      	var ratio = '';
        if (boostPFSThemeConfig.custom.product_grid_image_size != 'natural') {
          object_contain_grid = true;
          ratio = boostPFSThemeConfig.custom.product_grid_image_size;
        }
        if (object_contain_grid) {
          itemImagesHtml += '<div class="gallery-image-cropped relative" style="padding-top: ' + (1 / ratio * 100) + '%;">';
          itemImagesHtml += buildImages(data, true);
          itemImagesHtml += '</div>';
        } else {
          itemImagesHtml += buildResponsiveImages(data);
        }
        if (images.length > 1 && boostPFSThemeConfig.custom.products_show_second_image_on_hover) {
          itemImagesHtml += '<div class="product-item-hover bg-{{sectionColor}}-background lazyload absolute top-0 left-0 bottom-0 right-0 opacity-0 z-10 ' + (object_contain_grid ? 'bg-contain' : 'bg-cover') + ' bg-no-repeat bg-center transition-opacity duration-200 ease-in-out  group-hover:opacity-100" ' +
              					'data-bgset="' + buildResponsiveBgImages(images[1]) + '" data-sizes="auto" data-parent-fit="cover">';
          itemImagesHtml += '</div>';
        }
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
      
      	// Build Vendor
      	var itemVendorHtml = '';
        if (boostPFSThemeConfig.custom.product_grid_show_vendor && data.vendor !== '') {
          itemVendorHtml += '<p class="mb-1 text-{{sectionColor}}-meta ' + (soldOut ? 'line-through' : '') + '">' + data.vendor + '</p>';
        }
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
      
      	// Build Custom Title
      	var product_title_array = data.title.split(" ");
      	var otherTitleArray = '';
        for (var i = 1; i < product_title_array.length; i++) {
          otherTitleArray += product_title_array[i];
          if (i < product_title_array.length - 1) otherTitleArray += ' ';
        }
      	itemHtml = itemHtml.replace(/{{firstTitleArray}}/g, product_title_array[0]);
      	itemHtml = itemHtml.replace(/{{otherTitleArray}}/g, otherTitleArray);
      	
      	// Build Price
      	var itemPriceHtml = '';
        if(data.price_min > 0){
          if (onSale) {
            itemPriceHtml += ' <span class="rm-text-bold text-{{sectionColor}}-accent"><span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>' + Utils.formatMoney(data.price_min) + '</span>';
            itemPriceHtml += '<s class="inline"><span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>' + Utils.formatMoney(data.compare_at_price_min) + '</s>';
          } else {
            if (priceVaries) {
              itemPriceHtml += '<span>' + boostPFSThemeConfig.label.from_lowest_price_html.replace('{{ lowest_price }}', Utils.formatMoney(data.price_min)) + '</span>';
            } else {
              itemPriceHtml += '<span>' + Utils.formatMoney(data.price_min) + '</span>';
            }
          }
        }
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
		// Build Swatches
		var itemSwatchesHtml = '';
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

        var addToCartHtml = '';
        if(!soldOut){
          addToCartHtml += `<div class="single-product-add-to-cart">
          <button class="product-add-to-cart-button" data-variant-id="`+ data.variants[0].id +`">
              <span class="inline-block w-8 h-8 fill-current align-top icon-cart"><img style="width:13px" src="https://cdn.shopify.com/s/files/1/0752/3696/6705/files/Vector_2.png?v=1683736949">
          </span>
              <span class="inline-block w-8 h-8 fill-current align-top icon-loader" style="display: none"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
          <path fill="#000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="50 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
          </path>
          </svg></span>
          </button>
          </div>`;
        }
        itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, addToCartHtml);

        var wishListHtml = '';
        if(data.tags.indexOf('hide_buy') == -1){
          wishListHtml = '<span class="smartwishlist" data-product="'+ data.id +'" data-variant="'+ data.variants[0].id +'"></span>';
        }
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, wishListHtml);

        if(data.tags.includes('Background-white')){
          itemHtml = itemHtml.replace(/{{itemBackgroundWhite}}/g, 'background-color: white;');
        }else{
          itemHtml = itemHtml.replace(/{{itemBackgroundWhite}}/g, 'background-color: transparent;');
        }
      
		// Add a specific class for grid item
		itemHtml = itemHtml.replace(/{{titleDisplay}}/g, boostPFSThemeConfig.custom.title_price_display !== 'hover' ? 'hover:text-{{sectionColor}}-accent' : '');
		itemHtml = itemHtml.replace(/{{mobileColSpan}}/g, boostPFSThemeConfig.custom.mobile_col_span);
		itemHtml = itemHtml.replace(/{{desktopColSpan}}/g, boostPFSThemeConfig.custom.desktop_col_span);
		itemHtml = itemHtml.replace(/{{gridUppercase}}/g, boostPFSThemeConfig.custom.product_grid_uppercase ? 'uppercase' : '');
		itemHtml = itemHtml.replace(/{{layoutClass}}/g, boostPFSThemeConfig.custom.layout_class);
		itemHtml = itemHtml.replace(/{{titleClass}}/g, boostPFSThemeConfig.custom.title_class);
		itemHtml = itemHtml.replace(/{{priceClass}}/g, boostPFSThemeConfig.custom.price_class);
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOut ? 'text-{{sectionColor}}-meta line-through' : '');
		itemHtml = itemHtml.replace(/{{sectionColor}}/g, boostPFSThemeConfig.custom.section_color);
      
        var fillImageStyle = '';
        if (!boostPFSThemeConfig.custom.fill_image_to_border_edge) {
          if (boostPFSThemeConfig.custom.title_price_display == 'under_image') {
            fillImageStyle += 'pt-2 lg:pt-4';
          } else {
            fillImageStyle += 'py-2 lg:py-4';
          }
        }
		itemHtml = itemHtml.replace(/{{fillImageStyle}}/g, fillImageStyle);
      
      	var priceDisplayStyle = '';
        if (boostPFSThemeConfig.custom.title_price_display == 'under_image' && boostPFSThemeConfig.custom.fill_image_to_border_edge) {
          priceDisplayStyle += 'border-b-grid border-grid-color pb-0 lg:pb';
        }
		itemHtml = itemHtml.replace(/{{priceDisplayStyle}}/g, priceDisplayStyle);
      
      	var priceDisplayStyle2 = '';
        if (boostPFSThemeConfig.custom.title_price_display == 'on_hover' || boostPFSThemeConfig.custom.title_price_display.indexOf('over_image') !== -1) {
          priceDisplayStyle2 += 'absolute ';
          if (boostPFSThemeConfig.custom.fill_image_to_border_edge) {
            if (boostPFSThemeConfig.custom.title_price_display == 'over_image_top') {
              priceDisplayStyle2 += 'top-0 ';
            } else {
              priceDisplayStyle2 += 'bottom-0 ';
            }
            priceDisplayStyle2 += 'left-0 right-0 ';
          } else {
            priceDisplayStyle2 += 'left-4 right-4 ';
            if (boostPFSThemeConfig.custom.title_price_display == 'over_image_top') {
              priceDisplayStyle2 += 'top-4 ';
            } else {
              priceDisplayStyle2 += 'bottom-4 ';
            }
          }
        }
        if (boostPFSThemeConfig.custom.title_price_display == 'on_hover') {
          priceDisplayStyle2 += 'product-grid__meta opacity-0 group-hover:opacity-100 ';
          if (boostPFSThemeConfig.custom.fill_image_to_border_edge) {
            priceDisplayStyle2 += 'border-t-grid border-grid-color  bg-{{sectionColor}}-background ';
          }
          priceDisplayStyle2 += 'transition-opacity duration-200 ease-in-out text-{{sectionColor}}-text';
        }
		itemHtml = itemHtml.replace(/{{priceDisplayStyle2}}/g, priceDisplayStyle2);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

    function buildImages(data, contain) {
      var html = '';
      
      var image_url = Utils.getFeaturedImage(data.images_info, '1x1').replace('_1x1.', '_{width}x.');
      var aspect_ratio = data.images_info.length > 0 ? data.images_info[0]['height'] / data.images_info[0]['width'] : 1;
      var position_class = 'absolute left-0 top-0 bottom-0 right-0';
      var object_class = contain ? 'object-contain' : 'object-cover';
      
      html += '<img class="responsive-image block lazyload w-full h-full ' + position_class + ' ' + object_class + ' transition-opacity duration-200 ease-in-out" ' +
  				'data-src="' + image_url + '" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" tabindex="-1" alt="{{itemTitle}}">';
      html += '<div class="responsive-image-placeholder ' + position_class + '"></div>';
      html += '<noscript>';
      html += '<img class="' + position_class + ' ' + object_class + ' w-full h-full" src="' + Utils.getFeaturedImage(data.images_info, '2048x2048') + '" alt="{{itemTitle}}">';
      html += '</noscript>';
          
      return html;
    }
  
    function buildResponsiveImages(data) {
      var html = '';
      
      var image_widths = '180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024';
      if (data.images_info.length > 0) {
        var image = data.images_info[0];
        image_widths = image_widths.split(',');
        var image_width = ''
        for (var i = 0; i < image_widths.length; i++) {
          var width = image_widths[i];

          if (image.width >= width) {
            image_width += width + ','
          }
        }
        image_width += image.width;
        image_widths = image_width;
      }
      var image_url = Utils.getFeaturedImage(data.images_info, '1x1').replace('_1x1.', '_{width}x.');
      var aspect_ratio = data.images_info.length > 0 ? data.images_info[0]['height'] / data.images_info[0]['width'] : 1;
      console.log(aspect_ratio);
      html += '<div data-image-id="' + (data.images_info.length > 0 ? data.images_info[0]['id'] : '') + '" class="responsive-image-wrapper relative overflow-hidden w-full my-0 mx-auto" ' +
     			'style="height: 0; padding-top: ' + (100 * aspect_ratio) + '%;">';
      html += '<img class="responsive-image block absolute top-0 left-0 w-full h-full lazyload transition-opacity duration-200 ease-in-out w-full max-w-full h-auto" ' +
       			'data-src="' + image_url + '" data-widths="[' + image_widths + ']" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" tabindex="-1" alt="{{itemTitle}}">';
      html += '</div>';
      
      return html;
    }
  
    function buildResponsiveBgImages(image){
      var bgset = '';
      
      if(image){
        var aspect_ratio = image.width / image.height;

        if ( image.width > 180 ) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180/aspect_ratio) + 'h,';
        if ( image.width > 360 ) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360/aspect_ratio) + 'h,';
        if ( image.width > 540 ) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540/aspect_ratio) + 'h,';
        if ( image.width > 720 ) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720/aspect_ratio) + 'h,';
        if ( image.width > 900 ) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900/aspect_ratio) + 'h,';
        if ( image.width > 1080 ) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080/aspect_ratio) + 'h,';
        if ( image.width > 1296 ) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296/aspect_ratio) + 'h,';
        if ( image.width > 1512 ) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512/aspect_ratio) + 'h,';
        if ( image.width > 1728 ) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728/aspect_ratio) + 'h,';
        if ( image.width > 1950 ) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950/aspect_ratio) + 'h,';
        if ( image.width > 2100 ) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100/aspect_ratio) + 'h,';
        if ( image.width > 2260 ) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260/aspect_ratio) + 'h,';
        if ( image.width > 2450 ) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450/aspect_ratio) + 'h,';
        if ( image.width > 2700 ) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700/aspect_ratio) + 'h,';
        if ( image.width > 3000 ) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000/aspect_ratio) + 'h,';
        if ( image.width > 3350 ) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350/aspect_ratio) + 'h,';
        if ( image.width > 3750 ) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750/aspect_ratio) + 'h,';
        if ( image.width > 4100 ) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100/aspect_ratio) + 'h,';
        bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
      }
      
      return bgset;
    }

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}

        if (data.event_type != 'init' && typeof ReloadSmartWishlist !== 'undefined') { ReloadSmartWishlist(); }
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

    jQ(document).on("click", ".boost-pfs-filter-products .product-add-to-cart-button", function (evt) {
      const icon_cart = jQ(this).find('.icon-cart');
      const icon_loader = jQ(this).find('.icon-loader');
      icon_cart.hide();
      icon_loader.show();
      var formData = {
        'items': [{
          'id': jQ(this).data('variant-id'),
          'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          icon_cart.show();
          icon_loader.hide();
          document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem')); //dispatch event if cart mode is set to page
        })
        .catch((error) => {
          // console.error('Error:', error);
          icon_cart.show();
          icon_loader.hide();
        });
      evt.preventDefault();
      return false;
    })
})();